import { authRequest } from './client';
import {
  type ListTransactionsParams,
  type ListTransactionsResponse,
  type TransactionAssetOptionItem,
  type TransactionDetailResponse,
} from './types';

// ─── backoffice-api transactions client ────────────────────────────────────
//
// Thin fetch wrappers around backoffice-api's `/v1/transactions` endpoints
// (Task 30 — global, cross-merchant, read-only). All three require
// TECH_VIEWER (or SUPERADMIN).

export function listTransactions(params: ListTransactionsParams = {}): Promise<ListTransactionsResponse> {
  const query = new URLSearchParams();

  if (params.page !== undefined) query.set('page', String(params.page));
  if (params.pageSize !== undefined) query.set('pageSize', String(params.pageSize));
  if (params.operation !== undefined) query.set('operation', params.operation);
  if (params.status !== undefined) query.set('status', params.status);
  if (params.assetId !== undefined) query.set('assetId', params.assetId);
  if (params.merchantId !== undefined) query.set('merchantId', params.merchantId);
  if (params.from !== undefined) query.set('from', params.from);
  if (params.to !== undefined) query.set('to', params.to);
  if (params.unmatched !== undefined) query.set('unmatched', String(params.unmatched));

  const qs = query.toString();
  return authRequest<ListTransactionsResponse>(`/transactions${qs ? `?${qs}` : ''}`);
}

export function getTransaction(id: string): Promise<TransactionDetailResponse> {
  return authRequest<TransactionDetailResponse>(`/transactions/${id}`);
}

/** Every asset (including disabled ones) for the transactions list's asset filter dropdown. */
export function getTransactionAssetOptions(): Promise<TransactionAssetOptionItem[]> {
  return authRequest<TransactionAssetOptionItem[]>('/transactions/asset-options');
}
